import type { Shop } from '@/entities/order/types/shop'

import { apiSlice } from '@/shared/api/apiSlice'
import { ServerResponse } from '@/shared/types/common'

export type DeliveryPointInfo = {
	DELIVERY_PRICE: string
	DELIVERY_DATE: string
}

export const shopsApiSlice = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getShops: builder.query<Shop[] | null, undefined>({
			query: () => ({
				url: `shops`,
				credentials: `include`
			}),
			transformResponse: (res: ServerResponse<Shop[]>) => {
				if (!res?.data) return null
				return res?.data
			}
		})
	})
})

export const { useGetShopsQuery } = shopsApiSlice
